import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const SeqPager = ({ prev, next, onChangePage }) => (
  <Pagination className="d-flex justify-content-center">
    <PaginationItem disabled={!prev}>
      <PaginationLink onClick={() => onChangePage(null)} href="#">
        先頭のページ
      </PaginationLink>
    </PaginationItem>
    <PaginationItem disabled={!prev}>
      <PaginationLink onClick={() => onChangePage(prev)} href="#">
        前のページ
      </PaginationLink>
    </PaginationItem>
    <PaginationItem disabled={!next}>
      <PaginationLink onClick={() => onChangePage(next)} href="#">
        次のページ
      </PaginationLink>
    </PaginationItem>
  </Pagination>
);

SeqPager.propTypes = {
  prev: PropTypes.string,
  next: PropTypes.string,
  onChangePage: PropTypes.func.isRequired,
};

export default CSSModules(SeqPager);
